import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { getPagedPaymentHistoryReport as getPagedPaymentHistoryReportApi } from "../../helpers/ServiceHelpers/backend_helper";

//getPagedPaymentHistoryReport
export const getPagedPaymentHistoryReport = createAsyncThunk(
  "payment/getPagedPaymentHistoryReport",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getPagedPaymentHistoryReportApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
